(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asp-help"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('asp-help')) {
    class AspHelp extends HTMLElement {
      connectedCallback() {
        if (this.helpBound) return;
        this.helpBound = true;
        this.topicLinks = [...this.querySelectorAll('[data-help-topic]')];
        this.panels = [...this.querySelectorAll('[data-help-panel]')];
        this.onHashChange = () => this.showHashTarget();
        this.onClick = (event) => {
          const link = event.target.closest('[data-help-topic]');
          if (!link || !this.contains(link)) return;
          event.preventDefault();
          this.showTopic(link.dataset.helpTopic);
          history.replaceState(null, '', link.getAttribute('href'));
        };
        this.onBlockSelect = (event) => {
          const question = event.target.closest('.asp-help__question');
          if (!question || !this.contains(question)) return;
          const panel = question.closest('[data-help-panel]');
          this.showTopic(panel.dataset.helpPanel);
          question.open = true;
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        window.addEventListener('hashchange', this.onHashChange);
        this.showTopic(this.panels[0]?.dataset.helpPanel);
        this.showHashTarget();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        window.removeEventListener('hashchange', this.onHashChange);
        this.helpBound = false;
      }
      showTopic(topic) {
        if (!this.panels.some((panel) => panel.dataset.helpPanel === topic)) return;
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.helpPanel !== topic; });
        this.topicLinks.forEach((link) => {
          if (link.dataset.helpTopic === topic) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }
      showHashTarget() {
        let id;
        try { id = decodeURIComponent(window.location.hash.slice(1)); }
        catch { return; }
        if (!id) return;
        const target = document.getElementById(id);
        if (!target || !this.contains(target)) return;
        const panel = target.matches('[data-help-panel]') ? target : target.closest('[data-help-panel]');
        if (!panel) return;
        this.showTopic(panel.dataset.helpPanel);
        if (target.matches('details')) target.open = true;
      }
    }
    customElements.define('asp-help', AspHelp);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
  class FooterMenu extends HTMLElement {
    constructor() {
      super();
      this.menus = this.querySelectorAll('details-disclosure');
      this.resetHandler = this.reset.bind(this);
      setTimeout(this.resetHandler, 50);
    }

    connectedCallback() {
      window.addEventListener('on:breakpoint-change', this.resetHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('on:breakpoint-change', this.resetHandler);
    }

    reset() {
      this.menus.forEach((menu) => {
        if (theme.mediaMatches.lg) {
          if (!menu.disclosure.open) {
            menu.open();
          }
          menu.toggle.setAttribute('tabindex', '-1');
        } else {
          if (menu.disclosure.open) {
            menu.close();
          }
          menu.toggle.removeAttribute('tabindex');
        }
      });
    }
  }

  customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
